/**
 * Intestazione aziendale usata nei documenti generati (preventivi, ordini, DDT).
 *
 * Nella demo i valori sono volutamente generici: non fanno riferimento a
 * nessuna azienda reale. Possono essere sovrascritti dall'ambiente al momento
 * della build, senza toccare il codice.
 */

const env = process.env;

export const companyProfile = {
  /** Ragione sociale mostrata in testata e nei dettagli di pagamento. */
  name: env.VUE_APP_COMPANY_NAME || "LiberoTratto CRM",

  /** Righe della testata, sotto il nome. Le voci vuote vengono ignorate. */
  headerLines: [
    env.VUE_APP_COMPANY_SUBTITLE || "Demo gestionale",
    env.VUE_APP_COMPANY_ADDRESS || "",
    env.VUE_APP_COMPANY_CITY || "",
    env.VUE_APP_COMPANY_CONTACT || "",
  ].filter(Boolean),

  /** IBAN mostrato nel riquadro "Dettagli pagamento". */
  iban: env.VUE_APP_COMPANY_IBAN || "IT00 0000 0000 0000 0000 0000 000",
};

/** Testata completa: nome + righe descrittive. */
export function companyHeaderLines() {
  return [companyProfile.name, ...companyProfile.headerLines];
}

export default companyProfile;
